import {Observable, throwError} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import * as UserActions from './user.actions';
import {UpdatedUserInfoAction} from './user.actions';
import {Action} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {AuthenticationService} from '../../service/authentication.service';
import {UserSettingsSignalStore} from '../user-settings/user-settings.signal-store';

/**
 * Effects contain the side effects for asynchronous calls so that our components can remain compact
 * We are listening on the Observable of all user actions until UserActions.UPDATE_USER_INFO is dispatched
 * on which we act here to call the AuthenticationService to fetch the new user info from the rest endpoint
 * We will then dispatch our own UserActions.UPDATED_USER_INFO which will be processed in the reducer
 *
 * If the call returns an error (e.g redirect due to authorization errors)
 * we clear the authorization token in the local storage
 */
@Injectable()
export class UserEffects {
  appScope: AppScope;
  authenticationService= inject(AuthenticationService);
  actions$= inject(Actions);
  readonly userSettingsSignalStore = inject(UserSettingsSignalStore);

  update$: Observable<Action> = createEffect(
    () => this.actions$.pipe(
      ofType(UserActions.UPDATE_USER_INFO)).pipe(
      switchMap(() =>
        this.authenticationService
          .getUserData()
          .pipe(tap((userInfo) =>
            this.userSettingsSignalStore.fetchUserSettings(userInfo.id)))
          .pipe(map(data => new UpdatedUserInfoAction(data)))
      ),
      catchError((e) => {
        this.authenticationService.clearToken();
        return throwError(e);
      }))
  );
}
